export default "__VITE_ASSET__B2Vp9kpc__"